import FeaturedBrands from './FeaturedBrands';
import AllProducts from './AllProducts';
import TitleTop from './TitleTop';

export { FeaturedBrands, AllProducts, TitleTop };
